import TopicChangesTag from "app/pages/sales-intelligence/common-components/TopicChangesTag/TopicChangesTag";
import signalsTrackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";

const IntentTopicChangesBadge = () => {
    return <TopicChangesTag onMouseEnter={() => signalsTrackingService.trackHoverCustomTag()} />;
};

export default IntentTopicChangesBadge;
